import React from "react";
import "./UberContentDivider.scss";

const UberContentDivider = () => (
    <div className="UberContentDivider" role="separator">
        <div className="UberContentDivider-line" />
    </div>
);

export default UberContentDivider;
